import React from "react";
import ReactApexChart from "react-apexcharts";
import { Card } from "antd";
import "./Barchart.scss";

const BarChart = ({
  title = "Bar Chart",
  categories = [],
  seriesData = [],
  barColor = "#ffbdad",
  tooltipText = "Received",
  maxLabelLength = 8, // 👈 configurable slice length
}) => {
  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      offsetX: -15,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: "50%",
        barMinHeight: 5,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "10px",
        colors: ["#000"],
      },
      formatter: (val) => (val ? val : 0),
    },
    xaxis: {
      categories,
      labels: {
        rotate: -45,
        formatter: (val) => {
          if (val && val.length > maxLabelLength) {
            return val.slice(0, maxLabelLength) + "...";
          }
          return val;
        },
        style: {
          color: "#00000B",
          fontFamily: "Gilroy",
          fontSize: "10px",
          fontWeight: 600,
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
      position: "bottom",
      tooltip: {
        enabled: false, // 👈 enables default Apex tooltip on x-axis hover
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const value = series[seriesIndex][dataPointIndex] || 0;
        const fullLabel = w.globals.labels[dataPointIndex]; 
        return `
          <div class="custom-tooltip">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-text">${fullLabel} (${(tooltipText)}) : </div>
            <div style="font-weight: bold" class="tooltip-text">${value}</div> 
          
          </div>`;
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
      hover: { filter: { type: "none" } },
    },
    colors: [barColor],
    grid: {
      strokeDashArray: 4,
      padding: {
        left: 10,
      },
    },
  };

  const series = [
    {
      name: "Count",
      data: seriesData,
    },
  ];

  return (
    <Card
      style={{
        borderRadius: 12,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
      className="card_0f_bargraph"
    >
      <h4 style={{ marginBottom: 8 }}>{title}</h4>
      <div
        className="wrapper_bargraph_"
        style={{
          flexGrow: 1,
          width: "100%",
          height: "100%",
          display: "flex",
        }}
      >
        <ReactApexChart
          className="chartWrapper"
          options={options}
          series={series}
          type="bar"
          height="100%"
          width="100%"
        />
      </div>
    </Card>
  );
};

export default BarChart;
